import { Link, useLocation } from 'react-router-dom';
import {
  Barbell,
  CalendarBlank,
  ChartLine,
  ClipboardText,
  UsersThree,
  type Icon,
} from '@phosphor-icons/react';
import { useAuth } from '@/core/AuthContext';
import { cn } from '@/shared/utils/cn';

export function BottomTabBar() {
  const { userData } = useAuth();
  const location = useLocation();

  const isTrainer = userData?.role === 'trainer';

  const tabs = isTrainer
    ? [
        { to: '/trainer/exercises', label: 'Exercises', icon: Barbell },
        { to: '/trainer/workouts', label: 'Workouts', icon: ClipboardText },
        { to: '/trainer/clients', label: 'Clients', icon: UsersThree },
      ]
    : [
        { to: '/client', label: 'Schedule', icon: CalendarBlank },
        { to: '/client/train', label: 'Train', icon: Barbell },
        { to: '/client/progress', label: 'Progress', icon: ChartLine },
      ];

  const isActive = (path: string) => {
    if (path === '/trainer' || path === '/client') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden glass border-t border-gray-200 dark:border-white/10 safe-bottom" data-testid="bottom-navigation">
      <div className="grid grid-cols-3 h-16">
        {tabs.map((tab) => {
          const active = isActive(tab.to);
          const Icon = tab.icon as Icon;
          return (
            <Link
              key={tab.to}
              to={tab.to}
              data-testid={`bottom-nav-${tab.label.toLowerCase().replace(/\s+/g, '-')}-link`}
              className={cn(
                'flex flex-col items-center justify-center gap-1 transition-all',
                active
                  ? 'text-primary-600 dark:text-primary-400'
                  : 'text-gray-600 dark:text-slate-400'
              )}
            >
              <span className="flex items-center justify-center">
                <Icon size={22} weight="bold" />
              </span>
              <span className="text-xs font-medium">{tab.label}</span>
              {active && (
                <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-primary-500 to-accent-500 rounded-t-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
